import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            涵盖电影、电视剧、综艺、动漫四大板块，满足您的各种观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl p-6 md:p-8 text-center hover:bg-primary-50/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                {cat.label}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.slug === 'movie' && '最新院线大片'}
                {cat.slug === 'tv' && '热门国产剧集'}
                {cat.slug === 'variety' && '爆笑综艺节目'}
                {cat.slug === 'anime' && '国产精品动漫'}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}